<template>
  <div class="flex flex-row ml-5 mr-5">
    <!-- 承認済 -->
    <div
      v-if="currentReceipt.option.viewType === 4"
      style="width: 888px; height: 568px; top: 50%;left: 50%;border-radius: 24px 0px 24px 24px; position: fixed; z-index:-1; transform: translate(-50%, -50%);"
      class="inline-block overflow-hidden text-left align-middle transition-all transform bg-green-lightest"
    />
    <!-- 承認待 -->
    <div
      v-if="
        currentReceipt.option.viewType === 5 ||
          currentReceipt.option.viewType === 6 ||
          currentReceipt.option.viewType === 7
      "
      style="width: 888px; height: 110px; top: 0%;left: 50%;border-radius: 24px 0px 0px 0px; position: fixed; z-index:-1; transform: translate(-50%, -50%);"
      class="inline-block overflow-hidden text-left align-middle transition-all transform bg-green-lightest"
    />
    <div
      style="width: 876px; height: 450px; top: 51%;left: 50%;border-radius: 24px; z-index:1; position: fixed; transform: translate(-50%, -50%); overflow-y: scroll; overflow-x:hidden;"
      class="bg-white"
    >
      <app-table v-bind="$attrs" class=" ml-3 mr-3 w-full">
        <template v-slot:table-body>
          <!-- 支出内容1 -->
          <tr
            :class="
              header.attr === 'expenseContent1' ||
              header.attr === 'officeMessage'
                ? 'border-none'
                : ''
            "
            class="border border-collapse border-dashed border-green border-t-0 border-l-0 border-r-0 h-12"
            style="height:49px; width:848px"
            v-for="(header, index) in headers"
            :key="'receipt-preview-header-' + index"
          >
            <!-- アイコン -->
            <td
              class="mt-2 items-center justify-center"
              style="width:30px; position: relative; top:3px;"
              v-if="currentReceipt.option.viewType == 4"
            >
              <approved-icn
                v-if="header.attr !== 'expenseContent2'"
                width="20"
                height="20"
              />
            </td>
            <td
              class="mt-2 items-center justify-center"
              style="width:30px; position: relative; top:3px;"
              v-else-if="currentReceipt.option.viewType === 1"
            >
              <approved-icn
                v-if="header.attr !== 'expenseContent2'"
                class="status-green"
                width="20"
                height="20"
              />
            </td>
            <td
              class="mt-2 items-center justify-center"
              style="width:30px; position: relative; "
              :style="
                currentReceipt.isPartial && header.attr == 'expenseAmount'
                  ? 'top:-10px;'
                  : 'top:3px;'
              "
              v-else
            >
              <div v-if="header.attr !== 'expenseContent2'">
                <rejected-icn
                  v-if="
                    (currentReceipt.option.viewType === 7 &&
                      sentBackTitle().includes(
                        header.attr
                          .split(/(?=[A-Z])/)
                          .join('_')
                          .toLowerCase(),
                      )) ||
                      header.comment
                  "
                  class="mb-1"
                  width="20"
                  height="20"
                />
                <wait-yellow-icn v-else width="20" height="20" />
              </div>
            </td>
            <td width="150px">
              <div v-if="header.attr == 'files'" class="mt-2 mb-2">
                <span class="text-lg font-bold text-green">{{
                  header.title
                }}</span
                ><br />
                <!-- <span class="text-green">画像クリックで</span><br />
                <span class="text-green">拡大表示</span> -->
              </div>
              <span v-else class="text-lg font-bold text-red">{{
                header.title
              }}</span>
              <LetterGreen
                v-if="header.attr == 'officeMessage'"
                class="pt-1 ml-1 mb-2 "
                style="display: inline-block;"
                width="18px"
                height="18px"
              ></LetterGreen>
            </td>
            <!-- 支出年月日 -->
            <td
              class="mt-2 items-center justify-center"
              v-if="header.attr == 'expenseDate'"
            >
              <AppPreviewSentBackItem
                color="green"
                :message="getSentBackItemMessage('expense_date')"
              />
              <div v-if="header.comment" class="flex flex-row items-center">
                <rejected-icn
                  class="mt-1.5 mr-1"
                  style="display: inline-block;"
                  width="16"
                  height="16"
                />
                <span
                  class="text-lg mt-1"
                  style="width: 590px; white-space: normal; align-items: center;"
                >
                  {{ header.comment }}<br />
                </span>
              </div>
              <span class="text-lg">
                {{ $filters.dateFormat(currentReceipt['expenseDate']) }} |
                {{
                  $filters.wareki(
                    currentReceipt['expenseDate'].replace(/-/g, '/'),
                  )
                }}
              </span>
            </td>

            <!-- 支払額 -->
            <td
              class="mt-2 items-center justify-center"
              v-else-if="
                !currentReceipt.isDistributed && header.attr == 'expenseAmount'
              "
            >
              <AppPreviewSentBackItem
                color="green"
                :message="getSentBackItemMessage('expense_amount')"
              />
              <div v-if="header.comment" class="flex flex-row items-center">
                <rejected-icn
                  class="mt-1.5 mr-1"
                  style="display: inline-block;"
                  width="16"
                  height="16"
                />
                <span
                  class="text-lg mt-1"
                  style="width: 590px; white-space: normal; align-items: center;"
                >
                  {{ header.comment }}<br />
                </span>
              </div>
              <span class="text-lg">
                {{ currentReceipt['expenseAmount'].toLocaleString() }}円
              </span>
            </td>

            <!-- 経費項目 -->
            <td
              class="mt-2 items-center justify-center"
              v-else-if="header.attr === 'expenseTypeId'"
            >
              <AppPreviewSentBackItem
                color="green"
                :message="getSentBackItemMessage('expense_type_id')"
              />
              <div v-if="header.comment" class="flex flex-row items-center">
                <rejected-icn
                  class="mt-1.5 mr-1"
                  style="display: inline-block;"
                  width="16"
                  height="16"
                />
                <span
                  class="text-lg mt-1"
                  style="width: 590px; white-space: normal; align-items: center;"
                >
                  {{ header.comment }}<br />
                </span>
              </div>
              <span
                class="text-lg"
                v-for="(type, index) in currentReceipt.expenseTypeId"
                :key="'receipt-preview-expense-type-' + index"
              >
                <p>{{ type.name }}</p>
                <p v-if="addComma(index)">
                  ,
                </p>
              </span>
            </td>
            <td
              class="mt-2 items-center justify-center"
              v-else-if="
                currentReceipt.isDistributed && header.attr == 'expenseAmount'
              "
            >
              <AppPreviewSentBackItem
                color="green"
                :message="getSentBackItemMessage('expense_amount')"
              />
              <span class="text-lg">
                {{ prorateCalc() }}
              </span>
            </td>
            <td
              v-else-if="header.attr == 'files' && imgUploader.imgs.length > 0"
              class="pt-2"
            >
              <!-- 新規作成時は画像をfilesに持っている -->
              <AppPreviewSentBackItem
                color="green"
                :message="getSentBackItemMessage('files')"
              />
              <div v-if="header.comment" class="flex flex-row items-center">
                <rejected-icn
                  class="mt-1.5 mr-1"
                  style="display: inline-block;"
                  width="16"
                  height="16"
                />
                <span
                  class="text-lg mt-1"
                  style="width: 590px; white-space: normal; align-items: center;"
                >
                  {{ header.comment }}<br />
                </span>
              </div>
              <span v-if="!currentReceipt.images" class="text-lg">
                <div v-for="(img, index) in currentReceipt.files" :key="index">
                  <img
                    class="mb-2"
                    v-if="img.normalImage"
                    :src="
                      img.blackImage == null ? img.normalImage : img.blackImage
                    "
                    @click="
                      openImgPreview('receipt', index, {
                        normalImage: img.normalImage,
                        blackImage: img.blackImage,
                      })
                    "
                  />
                </div>
              </span>
              <span v-else class="text-lg">
                <div v-for="(img, index) in currentReceipt.images" :key="index">
                  <span
                    v-if="currentUser.role_id !== 1"
                    :class="`text-red mb-1 ml-1`"
                    >※画像クリックで黒塗りダイアログが開きます</span
                  >
                  <img
                    class="mb-2"
                    v-if="img.normalImage"
                    :src="
                      img.blackImage == null ? img.normalImage : img.blackImage
                    "
                    @click="
                      openImgPreview('receipt', index, {
                        normalImage: img.normalImage,
                        blackImage: img.blackImage,
                      })
                    "
                  />
                </div>
              </span>
            </td>
            <td
              v-else-if="
                header.attr == 'files' && imgUploader.imgs.length === 0
              "
              class="pt-2"
            >
              <!-- 新規作成時は画像をfilesに持っている -->
              <AppPreviewSentBackItem
                color="green"
                :message="getSentBackItemMessage('files')"
              />
              <div v-if="header.comment" class="flex flex-row items-center">
                <rejected-icn
                  class="mt-1.5 mr-1"
                  style="display: inline-block;"
                  width="16"
                  height="16"
                />
                <span
                  class="text-lg mt-1"
                  style="width: 590px; white-space: normal; align-items: center;"
                >
                  {{ header.comment }}<br />
                </span>
              </div>
              &nbsp;
            </td>
            <!-- 支出内容1段目 -->
            <td v-else-if="header.attr == 'expenseContent1'">
              <AppPreviewSentBackItem
                color="green"
                :message="getSentBackItemMessage('expense_content1')"
              />
              <div v-if="header.comment" class="flex flex-row items-center">
                <rejected-icn
                  class="mt-1.5 mr-1"
                  style="display: inline-block;"
                  width="16"
                  height="16"
                />
                <span
                  class="text-lg mt-1"
                  style="width: 590px; white-space: normal; align-items: center;"
                >
                  {{ header.comment }}<br />
                </span>
              </div>
              <span class="text-lg">
                {{ currentReceipt[header.attr] }}
              </span>
            </td>
            <!-- 支出内容２段目非表示 -->
            <td v-else-if="header.attr == 'expenseContent2'">
              <span class="text-lg">
                <AppPreviewSentBackItem
                  color="green"
                  :message="getSentBackItemMessage('expense_content2')"
                />
                <div v-if="header.comment" class="flex flex-row items-center">
                  <rejected-icn
                    class="mt-1.5 mr-1"
                    style="display: inline-block;"
                    width="16"
                    height="16"
                  />
                  <span
                    class="text-lg mt-1"
                    style="width: 590px; white-space: normal; align-items: center;"
                  >
                    {{ header.comment }}<br />
                  </span>
                </div>
                {{ currentReceipt[header.attr] }}&nbsp;
              </span>
            </td>
            <td v-else-if="header.attr == 'officeMessage' && !header.comment">
              <span>
                <AppPreviewSentBackItem
                  color="green"
                  :message="getSentBackItemMessage('office_message')"
                />
                <span
                  v-if="
                    !getSentBackItemMessage('office_message')[0]?.isNewest &&
                      currentUser.role.rank !== 1
                  "
                  class="text-green text-lg"
                >
                  新規メッセージを入力していません
                </span>
                <span v-else>&nbsp;</span>
              </span>
            </td>
            <td v-else-if="header.attr == 'officeMessage' && header.comment">
              <span>
                <AppPreviewSentBackItem
                  color="green"
                  :message="getSentBackItemMessage('office_message')"
                />
                <div class="flex flex-row items-center">
                  <rejected-icn
                    class="mt-1.5 mr-1"
                    style="display: inline-block;"
                    width="16"
                    height="16"
                  />
                  <span
                    class="text-lg mt-1"
                    style="width: 590px; white-space: normal; align-items: center;"
                  >
                    {{ header.comment }}<br />
                  </span>
                </div>
              </span>
            </td>
          </tr>
        </template>
      </app-table>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted } from 'vue'
import { useDialog } from '@/services/useDialog'
import AppTable from '@/components/ui/AppTable'
import { useReceiptDialog } from '@/services/receipt/useReceiptDialog'
import { useReceipts } from '@/services/receipt/useReceipts'
import { useReceiptForm } from '@/services/receipt/useReceiptForm'
import { useReceiptReject } from '@/services/receipt/useReceiptReject'
import ApprovedIcn from '@/assets/icons/approved.svg?inline'
import WaitYellowIcn from '@/assets/icons/wait-yellow.svg?inline'
import RejectedIcn from '@/assets/icons/rejected.svg?inline'
import LetterGreen from '@/assets/icons/letter-green.svg?inline'
import { useImgUploader } from '@/services/useImgUploader'
import { useCurrentUser } from '@/services/useCurrentUser'
import AppPreviewSentBackItem from '@/components/ui/AppPreviewSentBackItem'
export default {
  name: 'ReceiptPreview',
  components: {
    AppTable,
    ApprovedIcn,
    WaitYellowIcn,
    AppPreviewSentBackItem,
    RejectedIcn,
    LetterGreen,
  },

  setup() {
    const { imgUploader } = useImgUploader()

    const headers = reactive([
      { title: '経費項目', attr: 'expenseTypeId', comment: '' },
      { title: '支出額', attr: 'expenseAmount', comment: '' },
      { title: '支出年月日', attr: 'expenseDate', comment: '' },
      { title: '支出内容', attr: 'expenseContent1', comment: '' },
      { title: '補記', attr: 'expenseContent2', comment: '' },
      { title: '領収書添付', attr: 'files', comment: '' },
      { title: 'メッセージ', attr: 'officeMessage', comment: '' },
    ])

    const { currentReceipt } = useReceipts()
    const { rejectHeaders, rejectedAttrs } = useReceiptReject()
    onMounted(() => {
      let images = []

      if (currentReceipt.files.length == 0 && currentReceipt.images == null) {
        images = []
      } else {
        if (
          currentReceipt.files.length == 0 &&
          currentReceipt.images.length > 0
        ) {
          for (let i = 0; i < currentReceipt.images.length; i++) {
            currentReceipt.images[i].blackImage != null
              ? images.push(currentReceipt.images[i].blackImage)
              : images.push(currentReceipt.images[i].normalImage)
          }
        } else {
          for (let i = 0; i < currentReceipt.files.length; i++) {
            currentReceipt.files[i].blackImage != null
              ? images.push(currentReceipt.files[i].blackImage)
              : images.push(currentReceipt.files[i].normalImage)
          }
        }
      }
      imgUploader.error = ''
      imgUploader.files = []
      imgUploader.dropped = 0
      imgUploader.imgs = images

      if (rejectedAttrs.length > 0) {
        rejectedAttrs.forEach(item => {
          headers.forEach(header => {
            if (item.target === header.attr) {
              header.comment = item.comment
            }
          })
        })
      }
    })

    const addComma = index => {
      return (
        currentReceipt.expenseTypeId &&
        currentReceipt.expenseTypeId.length - 1 !== index &&
        currentReceipt.expenseTypeId.length > 1
      )
    }

    const sentBackTitle = () => {
      if (currentReceipt.sentBackItems.length > 0) {
        const sentBackTitles = []
        currentReceipt.sentBackItems[0].items.forEach(sentBackItem => {
          sentBackTitles.push(sentBackItem.target)
        })
        return sentBackTitles
      } else {
        return ''
      }
    }

    return {
      headers,
      currentReceipt,
      addComma,
      ...useDialog(),
      ...useReceiptDialog(),
      ...useReceiptForm(),
      imgUploader,
      ...useCurrentUser(),
      sentBackTitle,
      rejectHeaders,
      rejectedAttrs,
      ...useReceiptReject(),
    }
  },
}
</script>
<style lang="scss" scoped></style>
